import runWithTimeout from './runWithTimeout';

const TIMEOUT = 30 * 1000;

interface SkypePostMessage {
    messageId: string;
    status: number;
    responseText: string;
}

let lastMessageId = 0;

export default function callSkypeApi<T>(
    method: 'GET' | 'POST',
    url: string,
    contentWindow: Window,
    postData?: { [key: string]: string | boolean }
): Promise<T> {
    const currentMessageId = 'skype-post-' + lastMessageId++;
    let onMessage: (e: MessageEvent) => void;

    return runWithTimeout<T>(
        resolve => {
            onMessage = (e: MessageEvent) => {
                const message = tryParseJson<SkypePostMessage>(e.data);
                if (message && message.messageId == currentMessageId) {
                    const { status, responseText } = message;
                    const result =
                        status >= 200 && status < 300 ? tryParseJson<T>(responseText) : null;
                    resolve(result);
                }
            };

            window.addEventListener('message', onMessage);

            contentWindow.postMessage(
                JSON.stringify({
                    headers: getSkypApiHeaders(),
                    messageId: currentMessageId,
                    type: method,
                    url,
                    data: postData ? JSON.stringify(postData) : undefined,
                }),
                '*'
            );
        },
        () => {
            window.removeEventListener('message', onMessage);
        },
        TIMEOUT
    );
}

function getSkypApiHeaders() {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Ms-Namespace': 'internal',
        'X-Ms-SDK-Host': 'Exchange',
    };
}

function tryParseJson<T>(json: string): T {
    try {
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}
